import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { Grid, Panel, Col, Breadcrumb, ButtonToolbar, Button, Input } from 'react-bootstrap';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../../components/Layout/ContentWrapper';
import { numberWithCommas } from '../../Common/numberWithCommas';
import { UI_HEIGHT } from '../../Common/constants';
import CityReportTable from './cityReportTable';
import CityReportSearchPanel from './cityReportSearchPanel';
import { toFromDates } from '../../Common/cleanDates';
import checkPermission from '../../Common/permissions';
import { ROOT_URL, companyCodeTitle } from '../../../actions/root_url';

momentLocalizer(moment);

class CityReport extends Component {
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.customers,
      cityReportLines: [],
      fromDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      sale: 0,
      purchase: 0,
      ar: 0,
      ap: 0,
    };
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.cityReportLines !== nextProps.cityReportLines) {
      const {
        Cities, TotalSale, TotalPurchase, TotalAR, TotalAP,
      } = nextProps.cityReportLines;
      this.setState({
        cityReportLines: Cities, sale: TotalSale, purchase: TotalPurchase, ar: TotalAR, ap: TotalAP,
      });
    }
  }

  componentWillUnmount() {
    this.props.resetCityReport();
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton });
  }

  handleFieldUpdate = (data) => {
    this.setState({ [data.name]: data.value });
  }

  renderCityReportTable() {
    const { cityReportLines, tableHeight } = this.state;
    return (
      <CityReportTable
        rows={cityReportLines}
        minHeight={500}
      />
    );
  }

  renderPrintButton() {
    let { fromDate, toDate } = this.state;
    const dates = toFromDates(-1, fromDate, toDate);
    fromDate = `start_date=${dates.fromDate}`;
    toDate = `end_date=${dates.toDate}`;
    const token = `Bearer=${localStorage.getItem('token')}`;
    const url = `${ROOT_URL}v1/ar/cityreport/export/?${fromDate}&${toDate}&${token}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={url}
        disabled={!checkPermission('print_city_report')}
      >
        <em className="fa fa-download" /><Translate value="excel" />
      </Button>
    );
  }

  render() {
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="ar_slashsign_ap" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="city_report" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar>
          { this.renderPrintButton() }
        </ButtonToolbar>
        <Grid id="city-report">
          {/* <h1><Translate value="city_report" /></h1> */}
          <CityReportSearchPanel
            handleFieldUpdate={this.handleFieldUpdate}
          />
          <Panel id="city-report-table">
            { this.renderCityReportTable() }
          </Panel>
          <Panel><Col xs={12}>
            <div style={{ 'text-align': 'center' }}>
              <Col xs={3}>
                <label style={{ display: 'inline-flex', 'margin-top': '3px', 'margin-left': '10px' }}>
                  <Translate value="sale_total" /><span className="dollar-sign"> $$</span>:&nbsp;
                  <Input disabled type="text" value={`${numberWithCommas(this.state.sale)}` || 0} />
                </label>
              </Col>
              <Col xs={3}>
                <label style={{ display: 'inline-flex', 'margin-top': '3px', 'margin-left': '10px' }}>
                  <Translate value="purchase_total" /><span className="dollar-sign"> $$</span>:&nbsp;
                  <Input disabled type="text" value={`${numberWithCommas(this.state.purchase)}` || 0} />
                </label>
              </Col>
              <Col xs={3}>
                <label style={{ display: 'inline-flex', 'margin-top': '3px', 'margin-left': '10px' }}>
                  <Translate value="ar_total" /><span className="dollar-sign"> $$</span>:&nbsp;
                  <Input disabled type="text" value={`${numberWithCommas(this.state.ar)}` || 0} />
                </label>
              </Col>
              <Col xs={3}>
                <label style={{ display: 'inline-flex', 'margin-top': '3px', 'margin-left': '10px' }}>
                  <Translate value="ap_total" /><span className="dollar-sign"> $$</span>:&nbsp;
                  <Input disabled type="text" value={`${numberWithCommas(this.state.ap)}` || 0} />
                </label>
              </Col>
            </div>
          </Col>
          </Panel>
        </Grid>
      </ContentWrapper>
    );
  }
}

export default CityReport;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/CityReport/cityReport.jsx